import classes from './ContactUs.module.scss';
import { useState } from 'react';
import useForm from './useForm';
import FormRedirect from '../../organisms/formRedirect/FormRedirect';
import MarketingEmailList from '../../organisms/marketingEmailList/MarketingEmailList';
import areaCode from '../../../utils/data/countries.json';

export default function ContactUs(props) {
    const { handleChange, handleButton, isDisabled, inputsErrors, onSuccess, form } = useForm();

    const {
        0: siteContent,
        1: contactInfo,
        2: name,
        3: email,
        4: subject,
        5: phone,
        6: message,
        7: submit
    } = props;
    const { city_region, icon_country, street_address } = contactInfo;

    const address = street_address.split('\n');
    const subjectList = subject.list?.options;

    const defaultSelectValue = subjectList[0];
    const defaultCountryValue = areaCode[0];

    const [selected] = useState(defaultSelectValue);
    const [selectedCountry] = useState(defaultCountryValue);

    return (
        <div className={classes.oContactSection}>
            <div className={`${classes.oContactWrapper} container`}>
                <div className={`row no-gutters`}>
                    <h2 className={`aSectionTitle _accent fntH2`}>{siteContent.site_header}</h2>
                </div>
                <div className={`row`}>
                    <div className={`${classes.oColDetails} col-12 col-md-6`}>
                        <div className={classes.mPhysicalAddress}>
                            <span className={classes.mLocationWrapper}>
                                <figure className={classes.aIconLocation}>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
                                            fill="#29B2FF"
                                            fillOpacity="0.4"
                                            stroke="#003D66"
                                            strokeWidth="1.3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                                            stroke="#003D66"
                                            strokeWidth="1.3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </figure>
                                <p className={`${classes.aText} fnt18f`}>{icon_country}</p>
                            </span>
                            <h3 className={`${classes.aText} ${classes.city} fnt24f`}>
                                {city_region}
                            </h3>
                            <p className={`${classes.aText} ${classes.building} fnt16f`}>
                                {address[0]}
                                <br />
                                {address[1]}
                                <br />
                                {address[2]}
                                <br />
                                {address[3]}
                                <br />
                                {address[4]}
                            </p>
                        </div>
                        <hr className={classes.aContactHr} />
                        <MarketingEmailList {...props} />
                    </div>

                    <div className={`${classes.oColForm} col-12 col-md-6`}>
                        {onSuccess ? (
                            <FormRedirect ticketId={onSuccess} />
                        ) : (
                            <form
                                onSubmit={(e) => {
                                    handleButton(e);
                                }}
                                className={classes.contactForm}
                            >
                                <label className={classes.contactLabel}>
                                    <span className={`fnt12f`}>
                                        {name.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <input
                                        className={classes.contactInputs}
                                        type="text"
                                        name="name"
                                        pattern="[aA-zZ_ ]{0,100}"
                                        title="Please use only alphabets (a to z)."
                                        value={form.name}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={name.placeholder}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.name && name.error_message}
                                    </div>
                                </label>
                                <label className={classes.contactLabel}>
                                    <span className={`fnt12f`}>
                                        {email.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <input
                                        className={classes.contactInputs}
                                        type="email"
                                        name="email"
                                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,9}$"
                                        title="Invalid email"
                                        value={form.email}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={email.placeholder}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.email && email.error_message}
                                    </div>
                                </label>
                                <label className={classes.contactLabel}>
                                    <span className={`fnt12f`}>
                                        {subject.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <select
                                        className={classes.contactInputs}
                                        id="subjectSelect"
                                        name="subject"
                                        defaultValue={selected}
                                        style={{
                                            color:
                                                selected === defaultSelectValue ? 'gray' : 'black'
                                        }}
                                        onChange={(e) => handleChange(e)}
                                    >
                                        {subjectList.map((item) => (
                                            <option key={item} value={item}>
                                                {item}
                                            </option>
                                        ))}
                                    </select>
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.subject && subject.error_message}
                                    </div>
                                </label>
                                <label className={`${classes.contactLabel} ${classes.oPhoneField}`}>
                                    <span className={`fnt12f`}>
                                        {phone.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <div className={classes.oWrapper}>
                                        <span
                                            className={`${classes.mWrapper} ${classes.mCountryCode}`}
                                        >
                                            <select
                                                name="countryCode"
                                                id="countryCode"
                                                defaultValue={selectedCountry}
                                                className={`${classes.contactInputs} ${classes.countryCode}`}
                                                onChange={(e) => handleChange(e)}
                                                style={{
                                                    color:
                                                        selected === defaultSelectValue
                                                            ? 'gray'
                                                            : 'black'
                                                }}
                                            >
                                                {areaCode.map((intCodes, index) => (
                                                    <option
                                                        key={index}
                                                        value={`${intCodes.area_code}`}
                                                    >
                                                        {intCodes.name} | {intCodes.area_code}
                                                    </option>
                                                ))}
                                            </select>
                                        </span>
                                        <span className={`${classes.mWrapper} ${classes.mPhone}`}>
                                            <input
                                                className={classes.contactInputs}
                                                type="text"
                                                name="phone"
                                                pattern="^[0-9][0-9]{8,15}$"
                                                maxLength={15}
                                                title={`${phone.placeholder} (more than 8, less than 15 digits)`}
                                                value={form.phone}
                                                onChange={(e) => handleChange(e)}
                                                placeholder={phone.placeholder}
                                            />
                                        </span>
                                        <div
                                            className={`${classes.aError} ${classes.aText} fnt13f`}
                                        >
                                            {inputsErrors.phone && phone.error_message}
                                        </div>
                                    </div>
                                </label>
                                <label className={classes.contactLabel}>
                                    <span className={`fnt12f`}>
                                        {message.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <textarea
                                        className={classes.contactTextArea}
                                        name="message"
                                        value={form.message}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={message.placeholder}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.message && message.error_message}
                                    </div>
                                </label>
                                <div
                                    className={`${classes.oCtaWrapper} ${
                                        classes[`${isDisabled && 'hideButton'}`]
                                    }`}
                                >
                                    <span
                                        className={`${classes.mBtn} ${
                                            classes[`${isDisabled && 'hideButton'}`]
                                        } ${classes.iconButton}`}
                                    >
                                        <figure className={classes.mIcon}>
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.66634 7.99976H13.333"
                                                    stroke="white"
                                                    strokeWidth="0.976562"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M8.00016 13.3334L13.3335 8.00008L8.00016 2.66675"
                                                    stroke="white"
                                                    strokeWidth="0.976562"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </figure>
                                        <span className={`${classes.aText} fnt18f`}>
                                            {submit.label}
                                        </span>
                                        <input
                                            type="submit"
                                            value={submit.label}
                                            className={classes.inputClick}
                                            disabled={isDisabled}
                                        />
                                    </span>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
            <div className={classes.oBackgroundBlock}>
                <span className={`${classes.aBgCircle} ${classes.Orange1}`} />
                <span className={`${classes.aBgCircle} ${classes.Orange2}`} />
            </div>
        </div>
    );
}
